import { useEffect, useState } from 'react'

const TRUST_LABELS = [
  'Background checked',
  'ID verified',
  'First aid certified',
  '5-star rated',
]

export function useHomeViewModel(repository) {
  const [state, setState] = useState({ status: 'idle' })

  useEffect(() => {
    let cancelled = false

    async function load() {
      setState({ status: 'loading' })

      try {
        const nonnas = await repository.fetchFeaturedNonnas()
        if (!cancelled) {
          setState({ status: 'loaded', nonnas })
        }
      } catch (error) {
        if (!cancelled) {
          setState({
            status: 'failed',
            message: error?.message || 'Failed to load Nonnas.',
          })
        }
      }
    }

    void load()

    return () => {
      cancelled = true
    }
  }, [repository]) // eslint-disable-line

  return { ...state, trustLabels: TRUST_LABELS }
}